<template>
  <div class="dashboard__logo">
    <img :src="logo" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: null,
    };
  },
  mounted() {
    this.logo = localStorage.getItem('logo') || '';
  },
};
</script>

<style lang="scss" scoped>
.dashboard__logo {
  margin-top: 32px;
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;

  img {
    width: 100%;
    max-width: 350px;
  }
}
</style>
